import React from "react";
import { useParams } from "react-router-dom";
import products from "../data/products"; // Import products data

function ProductDetails() {
  const { productId } = useParams(); // Get product ID from the URL
  const product = products.find((p) => p.id === productId); // Find the product by ID

  if (!product) {
    return <div className="p-6 text-center">Product not found!</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl sm:text-4xl font-bold text-center mb-6">
        {product.name}
      </h1>
      <div className="flex flex-col items-center space-y-6 lg:space-y-0 lg:flex-row lg:space-x-8">
        {/* Product Image */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={product.image}
            alt={product.name}
            className="rounded-lg shadow-lg max-w-full h-auto"
          />
        </div>

        {/* Product Details */}
        <div className="w-full lg:w-1/2">
          {/* Features */}
          <h2 className="text-2xl font-semibold mb-4">Features</h2>
          <ul className="list-disc pl-6 text-gray-700 mb-6">
            {product.features.map((feature, index) => (
              <li key={index} className="mb-2">
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Technical Parameters */}
      <div className="mt-8">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Technical Parameters
        </h2>
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse border border-gray-400 w-full text-left">
            <thead>
              <tr>
                {product.tableHeaders.map((header, index) => (
                  <th
                    key={index}
                    className="border border-gray-400 px-4 py-2 bg-gray-200"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {product.tableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className="border border-gray-400 px-4 py-2"
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProductDetails;
